import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useScreenInit } from './useScreenInit.js';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Cursor } from './components/Cursor';
import { SessionTicker } from './components/SessionTicker';
import { MagicWord } from './components/MagicWord';
import { AmbientWash } from './components/AmbientWash';
import { Home } from './pages/Home';
import { Pricing } from './pages/Pricing';
export function App() {
  useScreenInit('scr_gg225t');
  return <BrowserRouter data-id="element-0">
      <div className="relative w-full bg-canvas text-slate-800" data-id="element-1">
        <AmbientWash data-id="element-2" />
        <Cursor data-id="element-3" />
        <Header data-id="element-4" />
        <main className="relative" data-id="element-5">
          <Routes data-id="element-6">
            <Route path="/" element={<Home data-id="element-8" />} data-id="element-7" />
            <Route path="/pricing" element={<Pricing data-id="element-10" />} data-id="element-9" />
          </Routes>
        </main>
        <Footer data-id="element-11" />
        <SessionTicker data-id="element-12" />
        <MagicWord data-id="element-13" />
      </div>
    </BrowserRouter>;
}